import React from 'react';

import classNames from 'classnames';

import classes from './styles.module.scss';

export default function FilterSwitch({
  activeFilterSwitchOption,
  setActiveFilterSwitchOption,
  filterSwitchOptions,
  top,
  left,
  right,
}) {
  return (
    <div className={classes.FilterSwitch} style={{ top, left, right }}>
      {filterSwitchOptions.map((option) => (
        <div
          role="tab"
          tabIndex={0}
          className={classNames(classes.option, {
            [classes.active]: activeFilterSwitchOption?.value === option.value,
          })}
          onClick={() => setActiveFilterSwitchOption(option)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              setActiveFilterSwitchOption(option);
            }
          }}
        >
          {option.label}{' '}
          <span className={classes.count}>{option.count || 0}</span>
        </div>
      ))}
    </div>
  );
}
